import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';
import { USERS_KEY } from './users';
import type { AccessRequest } from '@/types/api';

export const ACCESS_REQUESTS_KEY = ['access-requests'] as const;

export function useAccessRequests() {
  return useQuery({
    queryKey: ACCESS_REQUESTS_KEY,
    queryFn: async () => (await api.get<{ data: AccessRequest[] }>('/access-requests')).data,
  });
}

export function useApproveRequest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.post<{ data: unknown }>(`/access-requests/${id}/approve`),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ACCESS_REQUESTS_KEY });
      void queryClient.invalidateQueries({ queryKey: USERS_KEY });
    },
  });
}

export function useDeclineRequest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.post<void>(`/access-requests/${id}/decline`),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ACCESS_REQUESTS_KEY }),
  });
}
